import { render, staticRenderFns } from "./ImportAssembly.vue?vue&type=template&id=669d6eec&scoped=true"
import script from "./ImportAssembly.vue?vue&type=script&lang=ts"
export * from "./ImportAssembly.vue?vue&type=script&lang=ts"
import style0 from "./ImportAssembly.vue?vue&type=style&index=0&id=669d6eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669d6eec",
  null
  
)

export default component.exports